<template>
  <nav
    ref="target"
    :class="{
      'md:h-full': true,
    }"
  >
    <button
      v-if="model"
      type="button"
      aria-label="Active Menu"
      :class="{
        'absolute top-5 text-www-color-white md:hidden': true,
        'flex items-center gap-5': true,
        'pl-10 pr-6 text-right': true,
      }"
      @click="model = null"
    >
      <a
        :class="{
          'back-arrow inline-block rotate-[135deg] border-b-[3px] border-r-[3px] border-www-color-white p-3px': true,
        }"
      ></a>
      <p
        :class="{
          'leading-16 text-15px font-bold uppercase tracking-wider text-www-color-white': true,
        }"
      >
        {{ model }}
      </p>
    </button>

    <ul
      :class="{
        'text-13 flex h-full font-bold': true,
        'flex flex-col items-baseline gap-25px md:flex-row md:gap-0': true,
        'mx-py-0 px-50px pb-50px pt-25px md:px-0 md:py-0': true,
        'text-www-color-white md:text-www-color-neutral-medium-dark': !light,
        'text-www-color-white': light,
      }"
    >
      <template v-for="(navLink, index) in menus">
        <li
          v-if="navLink._type === 'generalLink'"
          :key="index"
          :class="{
            'relative mr-4 flex h-full items-center lg:mr-6 xl:mr-8': true,
          }"
        >
          <GeneralLink
            v-model="model"
            :index="index"
            v-bind="navLink"
            :class="{
              'text-13px font-bold uppercase tracking-wider md:text-[11px] lg:text-13px': true,
              'hover:text-www-color-primary-lighter': true,
              'whitespace-nowrap transition-all duration-300': true,
            }"
          />
        </li>
        <HeaderResourceDropdown
          v-else-if="navLink._type === 'resourceDropdown'"
          :key="navLink._key + '_resource'"
          v-model="model"
          v-bind="navLink"
        />
        <HeaderProductDropdown
          v-else-if="navLink._type === 'productDropdown'"
          :key="navLink._key + '_product'"
          v-model="model"
          :index="index"
          v-bind="navLink"
        />
        <HeaderSolutionsDropdown
          v-else-if="navLink._type === 'solutionsDropdown'"
          :key="navLink._key + '_solutions'"
          v-model="model"
          :index="index"
          v-bind="navLink"
        />
      </template>

      <!-- Appear in mobile only -->
      <li
        :class="{
          'flex items-center gap-1 md:hidden': true,
        }"
      >
        <GeneralLink
          v-bind="signinButton"
          :class="{
            'text-13px font-bold uppercase tracking-wider': true,
            'hover:text-www-color-primary-lighter': true,
            'transition-all duration-300': true,
          }"
        />
        <img
          alt="Sign In Arrow"
          :src="signInArrowImageSrc"
          width="15"
        />
      </li>
    </ul>
  </nav>
</template>
<script setup lang="ts">
import { onClickOutside } from '@vueuse/core';
import type { Header } from '~/sanity/types';
import GeneralLink from './GeneralLink.vue';
import HeaderResourceDropdown from './HeaderResourceDropdown.vue';
import HeaderProductDropdown from './HeaderProductDropdown.vue';
import HeaderSolutionsDropdown from './HeaderSolutionsDropdown.vue';

interface Props extends Header {
  light?: boolean;
}

defineProps<Props>();
const model = defineModel<string | null>({ default: null });
const target = ref(null);
onClickOutside(target, () => {
  model.value = null;
});
const { $staticImages } = useNuxtApp();
const signInArrowImageSrc = $staticImages['sign-in-arrow'];
</script>
